/* eslint-disable sonarjs/no-identical-functions */
import * as React from 'react';
import '../../../table/table.less';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { TableColumn } from '../../../table/types';
import { CoreHelper, WithCoreProps } from 'ff-shared-components-core';

export interface SubRowProps {
	/**Set a row to be used on details click */
	row?: any;
	/**Set a row id to be used on details click */
	rowId: string;
	/**Set the row columns  */
	columns?: TableColumn[];
	/**Set a checkbox(prefix) */
	withCheckbox?: boolean;
	/**Set an image(prefix) */
	withImage?: boolean;
	/**Set a pathToRedirect on details image click */
	pathToRedirect?: string;
	/**Sets if the checkbox is checked or not */
	isChecked?: boolean;
	/**Set headers to create sub-rows responsive appearance */
	headers?: string[];
	/**Sets an event to be handled on details click */
	onDetailsClick?: (row?: any) => void;
}

type Props = SubRowProps & RouteComponentProps;

class SubRowComponent extends React.PureComponent<Props> {
	render(): React.ReactNode {
		const { columns, rowId, row, headers, onDetailsClick } = this.props;
		return (
			<>
				<li className={`"ds-table-cell`}>
					{columns &&
						columns.map(
							(column: TableColumn, index: number): JSX.Element => {
								return (
									<React.Fragment key={CoreHelper.guid() || index}>
										<div
											className={`ds-table-cell-detail flex-column table-${
												index === 0 ? 'extra-big' : 'normal-currency'
											}-cell ${index === 0 ? 'clickable' : ''}`}
										>
											{index === 0 && (
												<span
													onClick={(): void => {
														onDetailsClick
															? onDetailsClick(row)
															: this.handleDetailsClick(rowId);
													}}
													className="ds-span ic-setatabela-after"
												>
													{column.value}
												</span>
											)}
											{index + 1 > 1 && (
												<>
													<span className="ds-table-hide">{headers && headers[index]}</span>
													<span>{column.value}</span>
												</>
											)}
										</div>

										{index + 1 === columns.length && (
											<div
												onClick={(): void => {
													onDetailsClick
														? onDetailsClick(row)
														: this.handleDetailsClick(rowId);
												}}
												className="ds-table-cell-detail flex-column ic-setatabela-after clickable table-small-cell"
											></div>
										)}
									</React.Fragment>
								);
							}
						)}
				</li>
			</>
		);
	}
	private readonly handleDetailsClick = (rowId: string): void => {
		const { pathToRedirect, history } = this.props;

		history.push(`${pathToRedirect}/${rowId}`);
	};
}

export const SubRow = WithCoreProps<SubRowProps>(withRouter(SubRowComponent));
